/**
 * MusicPlayer 进度条与拖拽预览 - 纯工具函数（抽离自 MusicPlayer.js）
 * 第一轮仅抽离 pctFromClientX、findNearestLyricIndex、applyMarqueeIfNeeded，
 * 供主文件内 progress/seek 逻辑使用。完整 useProgressSeek(refsRef, callbacksRef) 可后续再封装。
 */

export function pctFromClientX(clientX, trackEl) {
  if (!trackEl) return 0;
  const rect = trackEl.getBoundingClientRect();
  const x = clientX - rect.left;
  return rect.width > 0 ? x / rect.width : 0;
}

export function findNearestLyricIndex(t, arr) {
  if (!arr || arr.length === 0) return -1;
  let lo = 0;
  let hi = arr.length - 1;
  let best = -1;
  while (lo <= hi) {
    const mid = (lo + hi) >> 1;
    if (arr[mid].time <= t) {
      best = mid;
      lo = mid + 1;
    } else {
      hi = mid - 1;
    }
  }
  if (best < 0) return 0;
  if (best >= arr.length - 1) return best;
  const a = arr[best];
  const b = arr[best + 1];
  return (Math.abs(t - a.time) <= Math.abs(b.time - t)) ? best : (best + 1);
}

export function applyMarqueeIfNeeded(el, animRef, options = {}) {
  if (!el) return;
  const { speedPxPerSec = 42, pauseMs = 450 } = options;
  if (animRef?.current) {
    try {
      animRef.current.cancel();
    } catch (_) {}
    animRef.current = null;
  }
  el.style.whiteSpace = 'nowrap';
  el.style.overflow = 'hidden';
  requestAnimationFrame(() => {
    const overflow = el.scrollWidth - el.clientWidth;
    if (overflow <= 4) {
      el.style.transform = 'translateX(0px)';
      return;
    }
    const distance = overflow + 12;
    const duration = Math.max(1400, (distance / speedPxPerSec) * 1000);
    try {
      animRef.current = el.animate(
        [
          { transform: 'translateX(0px)' },
          { transform: `translateX(${-distance}px)` }
        ],
        {
          duration,
          iterations: Infinity,
          direction: 'alternate',
          easing: 'ease-in-out',
          delay: pauseMs
        }
      );
    } catch (_) {
      el.style.transform = 'translateX(0px)';
    }
  });
}
